import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

type ComicCardProps = {
  comic: Comic;
  showLatest?: boolean;
};

export default function ComicCard({ comic, showLatest = true }: ComicCardProps) {
  return (
    <Link
      to={`/detail/${comic.id}`}
      className="group block overflow-hidden rounded-lg border border-background-200 bg-background-50 transition hover:border-primary-300"
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden bg-background-200">
        <img
          src={comic.cover}
          alt={`${comic.title} 漫画封面`}
          title={`${comic.title} 在线漫画`}
          className="h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-full bg-foreground-950/70 px-2 py-0.5 text-xs text-background-50">
          {comic.status}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-0.5 rounded-full bg-accent-500 px-2 py-0.5 text-xs font-medium text-foreground-950">
          <i className="ri-star-fill" />
          {comic.rating.toFixed(1)}
        </span>
      </div>
      <div className="p-3">
        <h3 className="truncate text-sm font-medium text-foreground-900 transition group-hover:text-primary-600">
          {comic.title}
        </h3>
        <p className="mt-1 flex items-center gap-1 truncate text-xs text-foreground-500">
          <i className="ri-quill-pen-line" />
          {comic.author}
        </p>
        {showLatest && (
          <p className="mt-1.5 truncate text-xs text-secondary-600">
            <i className="ri-book-open-line mr-0.5" />
            {comic.latestChapter}
          </p>
        )}
      </div>
    </Link>
  );
}